import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../src/Layout/Footer/Footer";
import NavBar from "../src/Layout/NavBar/NavBar";
import Homepage from "./Pages/Homepage";
import { useState } from "react";
import Languages from "../src/Components/Languages/Languages";
import TrackRecord from "./Components/TrackRecord/TrackRecord";
import ScrollToTop from "./Common/ScrollToTop";
import AssetDetails from "./Components/AssetDetails/AssetDetails";
import GetInTouch from "./Components/GetInTouch/GetInTouch";
import OurValues from "./Components/OurValues/OurValues";
import KnowHow from "./Components/KnowHow/KnowHow";
import News from "./Components/News/News";
import Haltebrochure from "./Components/PDF/Haltebrochure";
import { useLocation } from "react-router-dom";
import Jacquemont from "./Components/PDF/Jacquemont";

const App = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const languages = [
    { code: "fr", name: "Français", country_code: "fr" },
    { code: "en", name: "English", country_code: "gb" },
  ];
  const location = useLocation();

  const { t } = useTranslation();
  return (
    <>
      {/* <NavBar /> */}
      {/* <Languages /> */}
      <ScrollToTop>
        <Routes>
          <Route path="/haltebrochure" element={<Haltebrochure />} />
          <Route path="/jacquemont" element={<Jacquemont />} />

          <Route
            path="/"
            element={
              <Homepage
                language={t}
                languages={languages}
                onOpen={(value) => setOpenMenu(value)}
                openMenu={openMenu}
              />
            }
          ></Route>
          <Route
            path="/our-portfolio/:assetName"
            element={
              <AssetDetails
                language={t}
                languages={languages}
                onOpen={(value) => setOpenMenu(value)}
                openMenu={openMenu}
              />
            }
          />
          <Route
            path="/our-portfolio"
            element={
              <TrackRecord
                language={t}
                languages={languages}
                onOpen={(value) => setOpenMenu(value)}
                openMenu={openMenu}
              />
            }
          ></Route>
          <Route
            path="/get-in-touch"
            element={
              <GetInTouch
                language={t}
                languages={languages}
                onOpen={(value) => setOpenMenu(value)}
                openMenu={openMenu}
              />
            }
          ></Route>
          <Route
            path="/our-values"
            element={
              <OurValues
                language={t}
                languages={languages}
                onOpen={(value) => setOpenMenu(value)}
                openMenu={openMenu}
              />
            }
          ></Route>
          <Route
            path="/news"
            element={
              <News
                language={t}
                languages={languages}
                onOpen={(value) => setOpenMenu(value)}
                openMenu={openMenu}
              />
            }
          ></Route>
        </Routes>
      </ScrollToTop>

      {location.pathname !== "/haltebrochure" ||
        (location.pathname !== "jacquemont" && (
          <Footer language={t} openMenu={openMenu} />
        ))}
    </>
  );
};

export default App;
